import { Button, Input } from 'ccs-ui-components';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SERVICE_OPERATION_MAXLENGTH } from '../../../../../../../constants/ServiceConstants';
import { IServiceOperationValidationModel } from '../../../../../../../models';
import classes from './QueryItemWrapper.module.scss';

interface IQueryParamFieldProps {
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  serviceOpsFormData: IServiceOperationValidationModel;
  onAddQueryHandler: () => void;
}
const QueryParamField = ({
  handleInputChange,
  serviceOpsFormData,
  onAddQueryHandler
}: IQueryParamFieldProps) => {
  const { t: translate } = useTranslation();

  const HELPER_TEXT = {
    name_ht: translate('helper_text.txt_name_ht'),
    value_ht: translate('helper_text.txt_value_ht')
  };

  const isAddQueryBtnEnabled = () =>
    !!(
      serviceOpsFormData.queryParamKey.isValid
      && serviceOpsFormData.queryParamKey.value
      && serviceOpsFormData.queryParamValue.isValid
      && serviceOpsFormData.queryParamValue.value
    );

  return (
    <Row className={classes['param-body']}>
      <Col sm={5}>
        <Input
          name="queryParamKey"
          label=""
          onChange={handleInputChange}
          value={serviceOpsFormData.queryParamKey.value}
          data-testid="query-param-key"
          placeholder={
            translate('service_operation_form.query_param_key') ?? ''
          }
          maxLength={Number(
            SERVICE_OPERATION_MAXLENGTH.queryPathParamMaxLength
          )}
          error={!serviceOpsFormData.queryParamKey.isValid}
          helperText={HELPER_TEXT.name_ht}
          errorTxt={serviceOpsFormData.queryParamKey.error}
          id="queryParamKey"
        />
      </Col>
      <Col sm={5}>
        <Input
          name="queryParamValue"
          label=""
          onChange={handleInputChange}
          value={serviceOpsFormData.queryParamValue.value}
          data-testid="query-param-value"
          placeholder={
            translate('service_operation_form.query_param_value') ?? ''
          }
          maxLength={Number(
            SERVICE_OPERATION_MAXLENGTH.queryPathParamMaxLength
          )}
          error={!serviceOpsFormData.queryParamValue.isValid}
          helperText={HELPER_TEXT.value_ht}
          errorTxt={serviceOpsFormData.queryParamValue.error}
          id="queryParamValue"
          className={classes['value-input']}
        />
      </Col>
      <Col sm={2}>
        <Button
          className={classes['add-button']}
          disabled={!isAddQueryBtnEnabled()}
          onClick={() => onAddQueryHandler()}
          data-testid="add-btn"
          variant="secondary"
        >
          {translate('service_operation_form.add_button')}
        </Button>
      </Col>
    </Row>
  );
};

export default QueryParamField;
